import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Markdown } from '@printdeal/markdown/react';
import { RichText } from '@printdeal/ui-library';

const query = graphql`
  {
  createComplaintPage: allContentfulPageSystem(
    filter: {pageSytemType: {eq: "complaintCreate"}}
  ) {
    nodes {
      contentField1 {
        contentField1
      }
    }
  }
}
`;

type QueryResult = {
  createComplaintPage: {
    nodes: {
      contentField1?: {
        contentField1: string;
      };
    }[];
  };
};

const ComplaintPolicyExplanation = () => {
  const { createComplaintPage: { nodes: [{ contentField1 }] } } = useStaticQuery<QueryResult>(query);

  if (!contentField1) {
    return null;
  }

  return (
    <RichText className="pd-text-center">
      <Markdown>{contentField1.contentField1}</Markdown>
    </RichText>
  );
};

export default ComplaintPolicyExplanation;
